export enum PreviewMode {
  FreeFlow= 'free-flow', //'only-questions',
  SimulateResponse = 'simulate-response' //'complete-flow'
}

const previewModeValues = Object.values(PreviewMode) as string[];
export function toPreviewMode(value: string | null | undefined, fallback: PreviewMode): PreviewMode {
  if (value && previewModeValues.includes(value)) {
    return value as PreviewMode;
  }
  return fallback;
}
